<template>
  <div id="mb-drag-and-drop" class="mb-drag-and-drop">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setValue(startGameConfig.mainImage.pos.x, 0) + 'px',
        left: setValue(startGameConfig.mainImage.pos.y, 0) + 'px',
      }"
    />
    <div v-if="show && items.length > 0" style="width: 100%; height: 100%">
      <div
        :key="'hook-' + indexHook"
        v-for="(hook, indexHook) in hooks"
        :style="{
          width: hook.width + 'px',
          height: hook.height + 'px',
          top: hook.pos.y + 'px',
          left: hook.pos.x + 'px',
          position: 'absolute',
          background: hook.background,
        }"
      >
        <img
          draggable="false"
          :src="giveMeImagePlease(hook.image)"
          v-if="hook.image"
          style="width: 100%; height: 100%"
        />
      </div>
      <vue-drag-resize
        class="puzzle-piece"
        :key="'crop-' + index"
        v-for="(it, index) in items"
        :is-resizable="false"
        :is-draggable="it.draggableFalse ? false : draggable"
        :is-active="false"
        :parent-limitation="true"
        :snap-to-grid="false"
        :w="it.width"
        :h="it.height"
        :x="it.pos.x"
        :y="it.pos.y"
        :z="it.z"
        :parent-w="1920"
        :parent-scale-x="setWidthScale()"
        :parent-scale-y="setHeightScale()"
        :parent-h="1080"
        :style="{
          'mix-blend-mode': letBlendMode(it),
          backgroundColor: it.background,
        }"
        @clicked="setZIndex(index, 2)"
        @dragstop="
          resize($event, index);
          setZIndex(index, 1);
        "
      >
        <img draggable="false" :src="it.backgroundImage" v-if="it.backgroundImage" style="width: 100%; height: 100%" />
      </vue-drag-resize>
    </div>
  </div>
</template>
<script>
import { Howler } from 'howler';
// import PreviewModal from './Preview/PreviewModal';
import defaultMixin from '../../mixins/defaultMixin';
export default {
  name: 'mb-drag-and-drop',
  components: {},
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      hooks: [],
      draggable: true,
      audio: null,
      items: [],
      correct: [],
      show: false,
      audioClick: null,
      audioNegative: null,
      audioPositive: null,
      canIPlayASong: true,
      canIClick: true,
    };
  },
  mounted() {
    this.audioInit();
    this.init();
    this.show = true;
  },
  methods: {
    letBlendMode(it) {
      if (it.connected != -1 && it.mixBlendColor && it.z == 0) {
        let result = this.items.filter((x) => x.connected == it.connected && x.correct == it.correct);
        console.log(result);
        if (result.length > 1) return it.mixBlendColor;
      }
      return '';
    },
    setWidthScale() {
      let itm = document.getElementById('mb-drag-and-drop').getBoundingClientRect();
      return itm.width / 1920;
    },
    setHeightScale() {
      let itm = document.getElementById('mb-drag-and-drop').getBoundingClientRect();
      return itm.height / 1080;
    },
    setValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    audioInit() {
      if (this.startGameConfig.audio) {
        if (this.startGameConfig.audio.positive) {
          this.audioPositive = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.positive),
            autoplay: false,
            loop: false,
            volume: 0.5,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
        if (this.startGameConfig.audio.click) {
          this.audioClick = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.click),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfig.audio.negative) {
          this.audioNegative = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.negative),
            autoplay: false,
            loop: false,
            volume: 0.5,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
      }
    },
    cancelCheck() {
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    checkGameAction() {
      return this.items.every((x) => x.correct == x.connected);
    },
    resetGameAction() {
      this.items = [];
      this.draggable = true;
      this.$nextTick(() => {
        this.init();
      });

      this.show = true;
    },
    info(data) {
      // console.log(data);
    },
    setZIndex(index, z) {
      if (this.draggable) {
        let it = this.items[index];
        it.z = z;
        this.$set(this.items, index, it);
      }
    },
    checkPosition(x, y, index) {
      // //console.log(this.$refs['puzzle-grid-0']);
      if (this.audioClick) this.audioClick.play();
      let hooks = document.getElementsByClassName('puzzle-grid-piece');
      ////console.log(hooks);
      this.hooks.forEach((hook, hookId) => {
        if (
          x >= parseInt(hook.pos.x) &&
          x <= parseInt(hook.pos.x) + parseInt(hook.width) &&
          y >= parseInt(hook.pos.y) &&
          y <= parseInt(hook.pos.y) + parseInt(hook.height)
        ) {
          ////console.log(i)
          // if (!this.items.some((x) => x.connected == hookId)) {
          this.items[index].pos.x = hook.pos.x;
          this.items[index].pos.y = hook.pos.y;
          this.items[index].connected = hookId;
          this.items[index].z = 0;
          // }
        }
      });
      if (this.checkGameAction()) {
        this.$store.dispatch('checkGame');
        this.draggable = false;
      }
    },
    resize(e, index) {
      let orginalPos = this.items[index].pos;
      this.items[index].pos.x = e.left;
      this.items[index].pos.y = e.top;
      this.items[index].connected = -1;
      ////console.log(e.left + this.puzzle[index].cropp.width / 2 + ' x ' + e.top + this.puzzle[index].cropp.height / 2);
      setTimeout(() => {
        this.checkPosition(e.left + this.items[index].width / 2, e.top + this.items[index].height / 2, index);
      }, 100);
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    init() {
      let grps = _.cloneDeep(this.startGameConfig.groups);
      let tmpHooks = _.cloneDeep(this.startGameConfig.hooks);
      this.hooks = tmpHooks;
      grps.forEach((group) => {
        let pos = this.shuffle(group.position);
        group.items.forEach((it, index) => {
          this.items.push({
            width: it.width,
            height: it.height,
            background: it.background,
            connected: -1,
            correct: it.correct,
            mixBlendColor: it.mixBlendColor,
            backgroundImage: this.giveMeImagePlease(it.image),
            pos: _.cloneDeep(pos[index]),
            draggable: it.draggable,
            z: 1,
          });
          if (it.static) {
            this.items.push({
              width: it.width,
              height: it.height,
              background: it.background,
              connected: -1,
              correct: -1,
              backgroundImage: this.giveMeImagePlease(it.image),
              pos: _.cloneDeep(pos[index]),
              draggableFalse: true,
              z: 0,
            });
          }
        });
      });
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandom(letters) {
      let tmp = '';
      tmp += letters[Math.floor(Math.random() * letters.length)];
      return tmp;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
  destroyed() {},
  computed: {
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mb-drag-and-drop
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 100%
  width: 100%
  top: 0px
</style>
